import { useEffect, useLayoutEffect } from "react"
import useInput from "../../../hooks/useInput"
import InputMessage from "../../ui/inputError"
import InputLabel from "../../ui/inputLabel"
import { strings } from "../../../assets/config/translations"

import './index.scss'

const TextArea = (props) => {
    const { ref,  bind, error, displayError, disabled} = useInput(props)
    const {register, deregister} = props 
    
    useLayoutEffect(() => {
        if (register){
            register(props.name, ref)
        }
        return () => {
            if (deregister){
                deregister(props.name)
            }
        }
    }, [])

    // Change to onchange on rest
    useEffect(() => {
        if (props.onRender) {
            props.onRender()
        }
    }, [bind.value])
    return (
        <div className={`input input-textarea ${props.className || ''}  ${error && displayError ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
            <InputLabel {...props}/>
            <div className="group">
                <textarea 
                    id={props.name}
                    rows="5" 
                    maxLength="500"
                    spellCheck
                    {...props}
                    {...bind}
                />
            </div>
            <InputMessage error={strings[error] || error}  displayError={displayError} {...props} information={<>{bind.value ? bind.value.length + "" : "0"}/{props.maxLength || "500"}</>} />
    </div>
    )
}

export default TextArea;